module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-02-iphone-frame.e3680f7a.png";